import ProfileTab from "./ProfileTab";
import { useRouter } from "next/router";
import { gql, useQuery } from "@apollo/client";
import { JURY_ROLE_ID } from "src/consts";

const AnswersQuery = gql`
  query Businesses {
    businesses {
      totalCount
      nodes {
        id
      }
    }
  }
`;

const JURYS_Query = gql`
  query Users($filters: UserFilters) {
    users(filters: $filters) {
      totalCount
      nodes {
        ... on User {
          role {
            id
            name
          }
        }
      }
    }
  }
`;

export default function JuryPresidentTabsSection() {
  const { data } = useQuery(AnswersQuery);
  const count = data?.businesses?.totalCount || 0;

  const { data: jurysData } = useQuery(JURYS_Query, {
    variables: {
      filters: {
        roleId: [JURY_ROLE_ID],
      },
    },
  });
  const JurysCount = jurysData?.users?.totalCount || 0;

  const router = useRouter();

  const tabs = [
    {
      title: "Les candidatures",
      subTitle:
        count > 0
          ? `${count} candidatures sont reçues`
          : "Aucune candidature reçue",
      link: "/jury-president/answers/",
    },
    {
      title: "Les jurys",
      subTitle:
        JurysCount > 0
          ? `Les profiles de ${JurysCount} jurys`
          : "Les profiles des jurys",
      link: "/jury-president/jurys/",
    },
  ];

  return (
    <section className="no-padding my-6 md:mb-6 md:mt-0 lg:mt-2">
      <div className="container mx-auto">
        <div className="border-b-gray-200 border-b flex flex-col md:flex-row gap-4 lg:gap-6 pb-4 md:pb-0">
          {tabs.map((tab) => (
            <ProfileTab
              {...tab}
              key={tab.link}
              active={router.asPath === tab.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
